import React, { useContext } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { ModalContext } from "context/ModalContext";
import AddProfession from "components/widgets/modals/AddProfession";
import NoData from "components/no-data/NoData";
import { file_url } from "services/apiSrv";
import routes from "routes";

// Styled Components
const PageHeader = styled.div`
  margin-bottom: 2rem;
`;

const Breadcrumb = styled.div`
  display: flex;
  padding: 0;
  margin: 0 0 1.25rem 0;
`;

const BreadcrumbItem = styled(Link)`
  color: #6c757d;
  text-decoration: none;
  display: flex;
  align-items: center;
  &.active {
    color: #212529;
    font-weight: bold;
  }
  &:hover {
    color: #007bff;
  }
  i {
    margin-right: 0.5rem;
  }
`;

const HeaderTitle = styled.h5`
  font-size: 1.25rem;
  margin: 0;
  font-weight: bold;
`;

const AddButton = styled.button`
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  border: none;
  background-color: #007bff;
  color: white;
  text-align: center;
  transition: transform 0.2s;
  float: right;
  margin: 1rem 0;
  &:hover {
    transform: translateY(-2px);
    background-color: #0056b3;
  }
`;

const MainContent = styled.main`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.5rem;
  padding: 1rem;
`;

const Card = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: white;
  background-image: url(${(props) => props.bgImage});
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
`;

const CardContent = styled.div`
  position: relative;
  padding: 1.5rem;
  text-align: center;
`;

const CardTitle = styled.h2`
  font-size: 1.25rem;
  color: white;
  margin-bottom: 1rem;
`;

const RemoveButton = styled.button`
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.25rem;
  border: none;
  background-color: red;
  margin-top: auto;
  color: white;
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-2px);
    background-color: #5a6268;
  }
`;

export default function Profession({ data }) {
  const { setModalShow, modalShow, modalClose } = useContext(ModalContext);

  return (
    <>
      <PageHeader className="pageheader">
        <Breadcrumb className="breadcrumb pd-0 mg-0 pd-b-20">
          <BreadcrumbItem className="breadcrumb-item active" to={routes.dashboard}>
            <i className="icon ion-ios-home-outline" /> Home
          </BreadcrumbItem>
          <BreadcrumbItem className="breadcrumb-item">Specialization</BreadcrumbItem>
        </Breadcrumb>
        <HeaderTitle>My Specialization(s)</HeaderTitle>
      </PageHeader>

      <div className="clearfix">
        <AddButton onClick={() => setModalShow(true)}>Add Specialization</AddButton>
      </div>

      {data.length === 0 ? (
        <NoData message="You currently don't have any professions" />
      ) : (
        <MainContent>
          {data.map((profession) => (
            <Card
              key={profession.code}
              bgImage={file_url + profession.icon}
            >
              <CardContent>
                <CardTitle>{profession.name}</CardTitle>
                <RemoveButton>Remove</RemoveButton>
              </CardContent>
            </Card>
          ))}
        </MainContent>
      )}

      {/* modal */}
      <AddProfession show={modalShow} onHide={modalClose} />
    </>
  );
}